import { LinearProgress, Stack } from "@mui/material";

import { AppBar } from "../appBar";
import { PageTitle } from "../pageTitle";
import { SearchBar } from "../searchBar";
import { useLanguageTranslator } from "../useLanguageContext";
import { ConditionalRenderer } from "../conditionalRenderer";
import I18nSelect from "../@common/I18nSelect";

function Header({
  loading = false,
  title,
  subtitle,
  setInputValue = () => {},
  inputValue = "",
  isSearchField = true,
}: any) {
  const { translator } = useLanguageTranslator();
  return (
    <AppBar>
      <Stack
        direction="row"
        flexGrow={1}
        alignItems="center"
        justifyContent="space-between"
      >
        <PageTitle title={title} subtitle={subtitle} />
        <div>
          <I18nSelect
            options={[
              { label: translator("English"), value: "en" },
              { label: translator("French"), value: "fr" },
              { label: translator("Portuguese"), value: "pt" },
            ]}
          />
          <ConditionalRenderer condition={isSearchField}>
            <SearchBar
              placeholder={translator("Search")}
              setInputValue={setInputValue}
              inputValue={inputValue}
            />
          </ConditionalRenderer>
        </div>
      </Stack>
      {loading && (
        <LinearProgress
          sx={{ position: "absolute", left: 0, right: 0, bottom: 0 }}
        />
      )}
    </AppBar>
  );
}

export { Header };
